// ============================================================================
// COMPANY API - Frontend
// API client para gestión de la empresa
// ============================================================================

import { api } from './client';

// ============================================================================
// TYPES
// ============================================================================

export interface Company {
  id: string;
  name: string;
  taxId: string;
  address: string | null;
  phone: string | null;
  email: string | null;
  logoUrl: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
  sitesCount: number;
  usersCount: number;
  patientsCount: number;
}

export interface UpdateCompanyDto {
  name?: string;
  taxId?: string;
  address?: string;
  phone?: string;
  email?: string;
  logoUrl?: string | null;
}

// ============================================================================
// API FUNCTIONS
// ============================================================================

export const companyApi = {
  /**
   * Obtener datos de la empresa
   */
  get: async (): Promise<Company> => {
    return api.get<Company>('/company');
  },

  /**
   * Actualizar datos de la empresa
   */
  update: async (data: UpdateCompanyDto): Promise<Company> => {
    return api.patch<Company>('/company', data);
  },
};

export default companyApi;
